export default __webpack_public_path__ + "static/media/gift-box.f1cfee2f.svg";